import { render } from "./AppMain.vue?vue&type=template&id=00d81a54&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=00d81a54&scoped=true&lang=css"
import "./AppMain.vue?vue&type=style&index=1&id=00d81a54&lang=scss"

import exportComponent from "/Users/arkane/Dev/Projects/Web/ecole-alpha.proj/ecole-alpha.2025-2026.web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.28_vue@3.3.8_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d81a54"]])

export default __exports__